export default {
  data() {
    return {
      // eslint-disable-next-line
      tradeOptionsType: [
        "Accountant",
        "Advisor",
        "Builder",
        "Business",
        "Coordinator",
        "Electrican",
        "Engineer",
        "Health",
        "Leader",
        "Manager",
        "Medical",
        "Operator",
        "Plumber",
        "Planner",
        "Safety",
        "Scientist",
        "Supervisor",
        "Superintendent",
        "Surveyor",
        "Technician",
        "Worker",
        "Other"
      ]
    };
  }
};
